import { Box, Grid, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { userQuery } from '../../../core/authentication/queries';
import { networkSectionsQuery, selectedNetworkSectionsQuery } from '../../../core/networkState/queries';
import { organizationQuery } from '../../../core/organization/queries';
import { useAppSelector } from '../../../types';
import { formatDistance } from '../../../utils/numbers';
import { Header } from '../../design_system/page/Header';
import { theme } from '../../legacy/style/theme';
import { OrganizationName, SessionUsername, Title } from '../../session/list-sessions/styles';

export const NetworkHeader = () => {
    const { t } = useTranslation();
    const organization = useAppSelector(organizationQuery);
    const user = useAppSelector(userQuery);
    const networkSections = useAppSelector(networkSectionsQuery);
    const selectedNetworkSections = useAppSelector(selectedNetworkSectionsQuery);
    const { count, totalDistance } = useMemo(() => {
        const meters = selectedNetworkSections.reduce(
            (sum, networkSection) => sum + Math.abs(networkSection.cumulEnd - networkSection.cumulStart),
            0,
        );

        return { count: selectedNetworkSections.length, totalDistance: formatDistance(meters) };
    }, [selectedNetworkSections]);

    return (
        <>
            <Grid container>
                <Grid item sx={{ display: 'flex', flexDirection: 'column', gap: 1, height: '100px' }} xs={3}>
                    <Title>{t('networkList.yourNetwork')}</Title>
                    {networkSections && count > 0 && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', mt: '-24px' }}>
                            <Typography sx={{ color: theme.color.blue.primary3, fontSize: '18px', fontWeight: 600 }}>
                                {t('networkList.selectedSections', { count })}
                            </Typography>
                            <Typography sx={{ color: theme.color.blue.primary3, fontSize: '14px', fontWeight: 500 }}>
                                {t('networkList.totalDistance', { totalDistance })}
                            </Typography>
                        </Box>
                    )}
                </Grid>
                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Header />
                </Grid>
                <Grid
                    item
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'end',
                        mt: '24px',
                        paddingRight: '6px',
                    }}
                    xs={3}
                >
                    <SessionUsername>
                        {user?.lastName} {user?.firstName}
                    </SessionUsername>
                    <OrganizationName>{organization?.name}</OrganizationName>
                </Grid>
            </Grid>
            <Box sx={{ height: 64 }} />
        </>
    );
};
